import styled from 'styled-components';

export const TextBoxContainer = styled.div`
  flex: 1;
`;

export const TextBox = styled.textarea`
  width: 100%;
  resize: none;
  outline: none;
  overflow-y: auto;
  max-height: 120px;
  white-space: normal;
  word-wrap: break-word;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  padding: 6px ${({ theme }) => theme.yoga.spacing.small}px;
  min-height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  &::placeholder {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
